import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

interface CustomerRequest {
    customer_category: number;
    status: boolean;
    customer_name: string;
    customer_post: string;
    customer_address: string;
    customer_address_detail: string;
    manager_name: string | null;
    manager_mobile: string | null;
    manager_email: string | null;
}

export const usePostCustomer = (successCallback?: (customerIdx: number) => void) => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation({
        mutationFn: async (customerData: CustomerRequest) => {
            const response = await axios.post(enum_api_uri.post_customer, customerData, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return response.data.data.customer_idx;
        },
        onSuccess: customerIdx => {
            queryClient.invalidateQueries({ queryKey: ["getCustomerList"] });
            successCallback?.(customerIdx);
        },
    });
};
